const Modal = ({
	setShowModal,
	type,
	title,
	content,
	handleSubmit,
	children,
	handleCloseModal,
	showFooterButtons = true,
	customButtons = null,
	centerTitle = false, // Ajout de la possibilité de centrer le titre
	maxWidth = 'max-w-md', // Ajout de la possibilité de personnaliser la largeur
	showModal = true, // Contrôle l'affichage de la modale
}) => {
	// Cette méthode ferme la modal si l'utilisateur clique en dehors de la modal
	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			setShowModal(false);
		}
	};

	if (!showModal) {
		return null;
	}

	return (
		<>
			{/* Overlay avec effet de flou */}
			<div
				className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm z-10"
				onClick={handleOverlayClick}
			></div>

			{/* Contenu de la modal */}
			<div className="fixed inset-0 z-20 flex items-center justify-center pointer-events-none p-4">
				<div className={`bg-white rounded-lg shadow-md w-full ${maxWidth} mx-4 pointer-events-auto max-h-[90vh] flex flex-col`}>
					{/* En-tête de la modal */}
					<div
						className={`${type === 'primary' || type === 'info' ? 'bg-primary' : 'bg-red-600'
							} h-[60px] rounded-t-lg flex items-center justify-between`}
					>
						<h2 className={`text-white font-bold text-lg px-4 py-2 ${centerTitle ? 'mx-auto' : ''}`}>{title}</h2>
						<button
							type="button"
							onClick={() => setShowModal(false)}
							className="text-white font-bold text-lg px-4 py-2"
						>
							&times;
						</button>
					</div>

					{/* Contenu de la modal */}
					<div className="py-12 px-4 overflow-y-auto flex-1">
						<p>
							{type === 'primary' && content
								? content
								: !children
									? 'Êtes-vous sûr de vouloir supprimer cet élément ?'
									: ''}
						</p>

						{children}
					</div>

					{/* Pied de page de la modal */}
					{showFooterButtons && (
						<div className="flex justify-end p-4 border-t border-gray-500">
							<button
								type="button"
								onClick={() => (handleCloseModal ? handleCloseModal() : setShowModal(false))}
								className="mr-4"
							>
								Annuler
							</button>

							<button
								type="button"
								onClick={handleSubmit}
								className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/80 transition duration-300"
							>
								Confirmer
							</button>
						</div>
					)}
					{customButtons && <div className="flex justify-end p-4 border-t border-gray-500">{customButtons}</div>}
				</div>
			</div>
		</>
	);
};

export default Modal;
